import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";
import "./PageOne.css";
import postatask from '../../assets/img/post-task.jpg';
import { fadeInLeft, fadeInRight } from 'react-animations';
import Radium, { StyleRoot } from 'radium';

const styles = {
  fadeInLeft: {
    animation: 'x 3s',
    animationName: Radium.keyframes(fadeInLeft, 'fadeInLeft')
  },
  fadeInRight: {
    animation: 'x 3s',
    animationName: Radium.keyframes(fadeInRight, 'fadeInRight')
  }
}
const PageOne = (props) => {


  const checkRemote = (e) => {
    if (e.target.value === 'No') {
      setRemotetask(true);
    }
    else {
      setRemotetask(false);
    }
  }

  const [remoteTask, setRemotetask] = useState(false);

  const { onPageNumberClick, onPageNumber, formik } = props;

  return (
    <StyleRoot>
      <main
        className="pt5 black-80 center"

      >
        <div className="container">
          <div className="row justify-content-center">
            {/* <div className="col-lg-6">
            <div className="postatask-img">
              <img src={postatask} alt='' className="img-fluid" />
            </div>
          </div> */}
            <div className="col-lg-6" style={styles.fadeInLeft}>
              <div className="post-tasks-main postatask-main">
                <div className="post-tasks">
                  <h5 className="post-tasks-title">Details</h5>
                </div>

                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>Title<span style={{ color: "#db3131" }}>*</span></Form.Label>
                  <Form.Control
                    name="title"
                    isValid={formik.touched.title && !formik.errors.title}
                    isInvalid={!!formik.errors.title}
                    onChange={formik.handleChange}
                    required
                    maxLength="40"
                    placeholder="Enter task title "
                  />
                  <Form.Control.Feedback type="invalid">{formik.errors.title}</Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                  <Form.Label>Describe your service requirement<span style={{ color: "#db3131" }}>*</span></Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    name="description"
                    isValid={formik.touched.description && !formik.errors.description}
                    isInvalid={!!formik.errors.description}
                    onChange={formik.handleChange}
                    required
                    maxLength="250"
                    placeholder="Enter your task description "
                  />
                  <Form.Control.Feedback type="invalid">{formik.errors.description}</Form.Control.Feedback>
                </Form.Group>

                <Form.Group controlId="formFileSm" className="mb-4">
                  <Form.Label>Add attachment (if any)</Form.Label>
                  <Form.Control
                    type="file"
                    name="related_file"
                    multiple
                    // onChange={formik.handleChange}
                    onChange={(e) => { props.handleFileChange(e) }}
                    size="sm"
                  />
                </Form.Group>

                <Form.Group controlId="formBasicEmail" className="mb-3">
                  <Form.Label className="mb-3">Can you perform this task remotely?</Form.Label>
                  <div className="mb-3">
                    <Form.Check
                      inline
                      label="Yes"
                      value="Yes"
                      name="remote"
                      type="radio"
                      // id={`inline-${type}-1`}
                      defaultChecked
                      onClick={(e) => { formik.handleChange(e); checkRemote(e) }}
                    />
                    <Form.Check
                      inline
                      label="No"
                      value="No"
                      name="remote"
                      type="radio"
                      // id={`inline-${type}-2`}
                      onClick={(e) => { formik.handleChange(e); checkRemote(e) }}
                    />
                  </div>

                </Form.Group>
                {remoteTask &&
                  <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>Task Location</Form.Label>
                    <Form.Control
                      type="text"
                      name="location"
                      onChange={formik.handleChange}
                      maxLength="100"
                      placeholder="Enter task location "
                    />
                  </Form.Group>
                }
                <div className='post-task-btn mt-4'>
                  <Button type="button" className="btn btn-primary" onClick={() => onPageNumber()}>Next</Button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </main>
    </StyleRoot>
  );
};

export default PageOne;
